import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { MortgageResponseItem } from "../../Calculator/types";

export interface StepFields {}

interface Props extends AbstractStepProps {
	loanAmount: number;
	maturity: number;
	result: MortgageResponseItem;
	variant?: string;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(_values: StepFields, _form: FormApi<StepFields>): ReactNode {
		const { loanAmount, maturity, result, variant } = this.props;

		if (!result) {
			return null;
		}

		const { apr, installmentStart } = result;

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center py-3">
					<mark className="bg-white text-primary display-6 font-weight-bold">
						{formatText(Math.floor(loanAmount / 1_000_000), "ft").replace("Ft", "millió Ft")} hitel{" "}
						{maturity} évre
					</mark>
					<div className="display-2 font-weight-bold mb-0 mt-3">{formatText(installmentStart, "ft")}</div>
					<div className="font-weight-bold mb-3">Havi törlesztőtől</div>
					<div className="display-6 font-weight-bold mb-3">{formatText(apr, "%")} THM-től</div>
					<div className="small">
						Beállításaid alapján ezekkel a<br /> kondíciókkal érhető el{" "}
						{variant === "freeUse" ? "jelzáloghitel" : "lakáshitel"}
					</div>
				</Card.Header>
				<Card.Body className="py-2">
					<div className="h4 text-center mb-3">
						A részletes eredményeidet
						<br />
						email-ben küldjük el
					</div>
					<List itemStyle="tick" variant="primary">
						<List.Item>
							Milyen <strong>kamattal</strong>, teljes <strong>visszafizetéssel</strong> és{" "}
							<strong>induló költséggel</strong> számolhatsz?
						</List.Item>
						<List.Item>
							<strong>Mennyi idő</strong> alatt és <strong>milyen feltételekkel</strong> kaphatod meg a
							fenti hitelt?
						</List.Item>
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen felmerülő kérdésedben
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" size="lg">
						Kérem az eredményeimet
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
